module.exports = __webpack_public_path__ + "img/tour_planning.23bd8039.svg";